import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const dataProviderName = 'campaigns/campaign';
const wizardAction = 'statuschange'

const ReassignmentReject = ({ selected, setSelected, onError }) => {
    const { t } = useTranslation();
    const { doAction } = useDataProvider(dataProviderName);


    const handleStatusChange = async () => {
        onError?.(null);
        const result = await doAction({
            action: wizardAction, 
            model: dataProviderName, 
            data: {selected:selected, status:'rejected'} 
        });

        if (result?.type === 'ACTION_FAILURE') {
            onError?.(result?.message || t('An error occurred while updating the reassignment request.'));
            return;
        }

        setSelected([]);
    };

    return [
        <>
            <Button
                onClick={handleStatusChange}
                label={t("Rifiuta (" + selected.length + ")")}
                icon="faThumbsDown"
                family="fas"
                variant="solid"
                size="small"
                className="button-select"
            />
        </>
    ];
};

export default ReassignmentReject;
